<template>
  <LayoutProfile :title_page="'Thông tin người dùng'">
    <div class="px-10 py-4">
      <form :action="route('profile.update')" method="post" class="mb-3">
        <slot></slot>
        <!-- Begin Infor -->
        <div
          class="p-2 grid grid-cols-1 sm:grid-cols-2 items-center gap-4 border-black border-b-2"
        >
          <div class="col-span-3 sm:col-span-1">
            <label
              for="hovaten"
              class="block text-white font-[Inder] text-xl font-normal"
            >
              Tên hiển thị:
            </label>
          </div>
          <div class="flex gap-3 items-center">
            <div class="col-span-3 sm:col-span-1">
              <input
                type="text"
                id="ten_hien_thi"
                name="ten_hien_thi"
                :value="infor.ten_hien_thi"
                class="mt-1 p-3 text-xl font-normal border-0 w-full text-white"
                :disabled="!isEdit"
                :style="!isEdit && 'background: none;'"
              />
            </div>
            <div>
              <button
                type="button"
                @click="toggleEdit"
                class="text-[#C60164] font-[Inder] text-xl font-normal"
              >
                {{ isEdit ? 'Hủy' : 'Sửa' }}
              </button>
            </div>
          </div>
        </div>

        <div
          class="p-2 grid grid-cols-1 sm:grid-cols-2 justify-between items-center gap-4 border-black border-b-2"
        >
          <div class="">
            <div class="col-span-3 sm:col-span-1">
              <label
                for="email"
                class="block text-white font-[Inder] text-xl font-normal"
                >Email:</label
              >
            </div>
          </div>

          <div class="flex gap-3 items-center">
            <div class="col-span-3 sm:col-span-1">
              <input
                type="text"
                id="email"
                name="email"
                :value="infor.email"
                class="mt-1 p-3 text-xl font-normal border-0 w-full text-white"
                :disabled="!isEditEmail"
                :style="!isEditEmail && 'background: none;'"
              />
            </div>
            <div>
              <button
                type="button"
                @click="toggleEditEmail"
                class="text-[#C60164] font-[Inder] text-xl font-normal"
              >
                {{ isEditEmail ? 'Hủy' : 'Sửa' }}
              </button>
            </div>
          </div>
        </div>
        <div
          class="p-2 grid grid-cols-1 sm:grid-cols-2 gap-4 border-black border-b-2"
        >
          <div class="col-span-3 sm:col-span-1">
            <label
              for="manaptien"
              class="block text-white font-[Inder] text-xl font-normal"
            >
              Số dư:
            </label>
          </div>
          <div class="col-span-3 sm:col-span-1 px-3">
            <label class="block text-xl font-semibold text-[#EE0303]">
              {{ formatCurrency(props.infor.tien) }}</label
            >
          </div>
        </div>

        <div
          class="p-2 grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2 border-black border-b-2"
        >
          <div class="col-span-3 sm:col-span-1">
            <label
              for="manaptien"
              class="block text-white font-[Inder] text-xl font-normal"
            >
              Mã nạp tiền:
            </label>
          </div>
          <div class="col-span-3 sm:col-span-1 px-3">
            <label class="block text-xl font-semibold text-white"
              >NAP {{ props.infor.id }}</label
            >
          </div>
        </div>

        <div class="flex justify-center mt-5">
          <button
            :type="isEdit && isEditEmail ? 'submit' : 'button'"
            :class="[
              'px-10 text-black font-[Inder] text-2xl py-1  rounded-2xl mt-2 bg-[#00DD8DBD]',
              isEdit && isEditEmail ? 'opacity-100' : 'opacity-60',
            ]"
          >
            Cập nhật
          </button>
        </div>
      </form>
    </div>
  </LayoutProfile>
</template>

<script setup>
import { ref } from 'vue'
import LayoutProfile from '../../Layouts/LayoutProfile.vue'
import route from 'ziggy-js'

const props = defineProps(['infor'])

const isEditEmail = ref(false)
const isEdit = ref(false)

const formatCurrency = (value) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(value)
}

const toggleEdit = () => {
  isEdit.value = !isEdit.value
}

const toggleEditEmail = () => {
  isEditEmail.value = !isEditEmail.value
}
</script>
